import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=a41afe50&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=ts"
export * from "./AddAdmin.vue?vue&type=script&lang=ts"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=a41afe50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41afe50",
  null
  
)

export default component.exports